import React, { useState, useEffect, useContext, Fragment } from 'react';

import { useHistory } from 'react-router-dom';
import useSound from 'use-sound';
import { setColor } from '../../styles/styles';

import useEffectAfterMount from '../../utils/hooks/useEffectAfterMount';
import sound1 from '../../styles/sounds/sound1.mp3';

import expoHallAPI from '../../api/expoHallAPI';

import { Context as AttendantContext } from '../../context/AttendantContext';

import styled from 'styled-components';

import AttendantDashboardTile from './AttendantDashboardTile';
import AttendantDashboardInfo from './AttendantDashboardInfo';

import ReactModal from 'react-modal';

import { DetailsButton } from '../globals/DetailsButton';

import RequestMeetingDetails from '../requestMeetingForm/RequestMeetingDetails';

import _ from 'lodash';
import { Context as SocketContext } from '../../context/SocketContext';
import Smallchatbox from '../Chatbox/Smallchatbox';
import SiteData from '../../config';
import NavbarAttendant from '../globals/NavbarAttendant';
import LoadingPage from '../../pages/LoadingPage';
import getTimeLogged from '../../utils/getTimeLogged';
import Countdown from 'react-countdown';
import { CustomNotification } from '../globals/NotificationAgreement';
import { Context as UserContext } from '../../context/UserContext';
import { LivePulse } from '../../pages/SliderPage';
import { Tooltip } from '@material-ui/core';

const AttendantDashboard = ({
  className,
  setAttendantNavbarBackLink,
}) => {
  const {
    state,
    state: { booth, attendant = {} } = {},
    setBooth,
    setAttendant,
  } = useContext(AttendantContext);

  const {
    state: { user },
    setUser,
  } = useContext(UserContext);
  const {
    state: {
      EventisLive,
    },
    setViewsNumber,
    setEventisLive,
  } = useContext(SocketContext);

  const {
    first_name = '',
    screen_name = '',
    last_name = '',
    email = '',
    password = '',
    booth: {
      id = '',
      name = '',
      //videocall_host_url = '',
      image = '',
    } = {},
  } = attendant;

  const history = useHistory();
  const [play] = useSound(sound1);
  const [droppedCards, setDroppedCards] = useState([]);
  const [requestedMeetings, setRequestedMeetings] = useState([]);
  // const [booth, setBooth] = useState({});
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [loadBooth, setLoadBooth] = useState(false);
  const [processed, setProcessed] = useState([]);
  const [openNotification, setOpenNotification] = useState(false);
  const [notificationData, setNotificationData] = useState({});

  const {
    chat_url,
    videocall_host_url,
    chat_toggle,
    business_card_toggle,
    video_call_toggle,
    meeting_toggle,
  } = booth;

  const [iFrameLinkGeneral, setIFrameLinkGeneral] = useState(null);

  useEffect(() => {
    if(first_name){
      const displayName = (screen_name && screen_name !== 'None') ? screen_name : first_name + ' '+ last_name;
      if (first_name || screen_name) {
        setIFrameLinkGeneral(
          `https://deadsimplechat.com/1gk2-UNSs?username=${displayName}`
        );
      }
    }
  }, [first_name, screen_name]);

  const [iFrameLinkBooth, setIFrameLinkBooth] = useState(null);

  useEffect(() => {
    if(first_name){
      const displayName = (screen_name && screen_name !== 'None') ? screen_name : first_name + ' '+ last_name;
      if (chat_url) {
        setIFrameLinkBooth(`${chat_url}?username=${displayName}`);
      }
    }
  }, [first_name, screen_name, chat_url]);

  

  const playSound = () => {
    play();
  };
  useEffect(() => {
    fetchUser();
  }, []);

  const handleMeetingCompleted = async (data) => {
    try {
      const response = await expoHallAPI.put(`/api/meetings/${data.id}/`, {
        processed: !data.processed,
      });
      handleProcessed(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (attendant.id) {
      getBooth();
      getNotification();
;
    }
  }, [attendant]);


  const getBooth = async () => {
    try {
      const token = localStorage.getItem('shrm-li-expo-attendant');
      expoHallAPI.defaults.headers.common['Authorization'] = 'Bearer ' + token;
      const { data } = await expoHallAPI.get(`/api/tiles/${attendant.id}/`);
      setDroppedCards(data.dropped_cards);
      setRequestedMeetings(data.meeting);
      setViewsNumber(data.views);
      setBooth(data);
      setLoadBooth(true);
    } catch (error) {}
  };

  const fetchUser = async () => {
    try {
      const token = localStorage.getItem('shrm-li-expo-attendant');
      expoHallAPI.defaults.headers.common['Authorization'] = 'Bearer ' + token;
      const { data } = await expoHallAPI.get('/attendant/profile/');
      if (data) {
        setAttendant(data);
      }
    } catch (error) {
      expoHallAPI.defaults.headers.common['Authorization'] = '';
      localStorage.removeItem('shrm-li-expo-attendant');
      history.push('/login');
      setAttendant(undefined);
    }
  };

  const handleProcessed = (data) => {
    const index = requestedMeetings.findIndex((x) => x.id === data.id);
    let array = requestedMeetings;
    array[index].processed = !data.processed;
    setProcessed(array[index].processed);
    setRequestedMeetings(array);
  };

  const getNotification = async () => {
    try {
      const { data } = await expoHallAPI.get('/api/notifications/expo/');
      data.map((eachData) => {
        timeTriggerActions(eachData);
      });
    } catch (error) {
      console.log(error);
    }
  };

  const timeTriggerNow = (data) => {
    const now = new Date();
    const TimeNow = Date.UTC(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate(),
      now.getUTCHours(),
      now.getUTCMinutes(),
      now.getUTCSeconds()
    );
    const EventTime = parseFloat(data.milliseconds);
    //time left for event
    let TimeLeftForEvent = EventTime - TimeNow;
    if (TimeLeftForEvent < 0) {
      TimeLeftForEvent += 86400000; // adds 1 day (runs everyday)
    }

    const eventDay = new Date(EventTime).getUTCDate();
    if (now.getUTCDate() === eventDay) {
      setTimeout(() => {
        auditoriumActions(data);
      }, TimeLeftForEvent);
    }
  };

  const timeTriggerPeriod = (data) => {
    const now = new Date();
    const EventTime = new Date(data.time);
    const EventEndTime = new Date(data.end_time);
    if (
      new Date(now.toUTCString()) > new Date(EventTime.toUTCString()) &&
      new Date(now.toUTCString()) < new Date(EventEndTime.toUTCString())
    ) {
      auditoriumActions(data);
    }
  };

  const timeTriggerActions = (data) => {
    switch (data.notif_type) {
      case 'NOW':
        timeTriggerNow(data);
        break;
      case 'PERIOD':
        timeTriggerPeriod(data);
        break;
      default:
      // code block
    }
  };

  const auditoriumActions = (data) => {
    const now = new Date(new Date().toUTCString());
    const EventTime = new Date(new Date(data.time).toUTCString());
    const differenceAfter = now.getTime() - EventTime.getTime();
    const differenceBefore = EventTime.getTime() - now.getTime();
    const minutes = Math.ceil(differenceBefore / 60000);

    getTimeLogged(data.id.toString());

    switch (data.action) {
      case 'linkNotification':
        setOpenNotification(true);
        data.buttonText = 'Click Here';
        data.time = '';
        setNotificationData(data);
        setTimeout(() => {
          setOpenNotification(false);
        }, 50000);
        break;
      case 'textNotification':
        setOpenNotification(true);
        data.buttonText = '';
        data.time = '';
        setNotificationData(data);
        setTimeout(() => {
          setOpenNotification(false);
        }, 50000);
        break;
      case 'movePages':
        proceedToAuditorium();
        break;
    }
  };

  const proceedToAuditorium = () => {
    history.push('/auditorium');
  };

  const customStyles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      zIndex: 900,
    },
    content: {
      height: '75%',
      width: '60%',
      transform: 'translate(-50%, -50%)',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      borderRadius: 0,
      borderWidth: 0,
      outline: 'none',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      backgroundColor: 'white',
      paddingLeft: 40,
      paddingRight: 80,
      backfaceVisibility: 'hidden',
      boxShadow: '0px 0px 48px 0px rgba(0,0,0,0.4)',
      overflow: 'hidden',
      zIndex: 1000,
    },
  };
  if (!loadBooth) {
    return <LoadingPage />;
  } else {
    return (
      <div className={className}>
        <CustomNotification
          title={notificationData.title}
          description={notificationData.message}
          time={notificationData.time}
          open={openNotification}
          onCloseIconClick={(e) => {
            setOpenNotification(false);
          }}
        />
        <ReactModal
          isOpen={modalIsOpen}
          style={customStyles}
          onRequestClose={() => setModalIsOpen(false)}
          ariaHideApp={false}
          className="ReactModal__customContent"
        >
          <RequestMeetingDetails
            handleProcessed={handleProcessed}
            data={modalIsOpen}
            closeModal={() => setModalIsOpen(false)}
          />
        </ReactModal>
        {EventisLive && (
          <Tooltip
            title={
              <h6
                style={{
                  color: 'white',
                  display: 'flex',
                  paddingTop: '0.5rem',
                }}
              >
                Auditorium is Live
              </h6>
            }
          >
            <LivePulse
              onClick={() => {
                proceedToAuditorium();
              }}
            />
          </Tooltip>
        )}
        <header>
          <h2>{name}</h2>
        </header>
        {video_call_toggle && (
          <AttendantDashboardInfo
            boothInfo={{
              id: booth.id,
              name,
              closed: booth.closed,
              videocallHostUrl: videocall_host_url,
              firstName: first_name,
              password,
            }}
          />
        )}

        <TileContainer>
          <AttendantDashboardTile title="event discussion" subtitle={'  '}>
            <iframe src={iFrameLinkGeneral} />
            
          </AttendantDashboardTile>
          {chat_toggle && (
            <AttendantDashboardTile
              title="session discussion"
            >
              <iframe src={iFrameLinkBooth} />
              
            </AttendantDashboardTile>
          )}
          {business_card_toggle && (
            <AttendantDashboardTile title="dropped cards">
              <div className="table">
                <div className="row">
                  <div className="emailDropCards row-data">Email</div>
                  <div className="first-nameDropCards row-data">First Name</div>
                  <div className="last-nameDropCards row-data">Last Name</div>
                </div>

                <div className="data-columns">
                  {droppedCards.map((card) => (
                    <div className="row" key={card.email}>
                      <div className="emailDropCards row-data">
                        {card.email}
                      </div>
                      <div className="first-nameDropCards row-data">
                        {card.first_name}
                      </div>
                      <div className="last-nameDropCards row-data">
                        {card.last_name}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </AttendantDashboardTile>
          )}
          {meeting_toggle && (
            <AttendantDashboardTile title="requested meetings">
              <div className="table">
                <div className="row">
                  <div className="emailMeetings row-data">Email@email.com</div>
                  <div className="first-nameMeetings row-data">First Name</div>
                  <div className="last-nameMeetings row-data">Last Name</div>
                  <div className="detailsMeetings row-data"></div>
                </div>
                <div className="data-columns">
                  {requestedMeetings.map((card, index) => {
                    return (
                      <div
                        className={card.processed ? 'rowCompleted' : 'row'}
                        key={index}
                      >
                        <div className="emailMeetings row-data">
                          {card.email}
                        </div>
                        <div className="first-nameMeetings row-data">
                          {card.first_name}
                        </div>
                        <div className="last-nameMeetings row-data">
                          {card.last_name}
                        </div>
                        <div className="detailsMeetings row-data details_button">
                          <DetailsButton onClick={() => setModalIsOpen(card)}>
                            Details
                          </DetailsButton>
                          <div className="meeting_checkbok">
                            <input
                              onClick={() => {
                                handleMeetingCompleted(card);
                              }}
                              checked={card.processed ? true : false}
                              name="meeting_complete"
                              id="meeting_complete"
                              type="checkbox"
                            />
                            <label htmlFor="meeting_complete"></label>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </AttendantDashboardTile>
          )}
        </TileContainer>
      </div>
    );
  }
};

const TileContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(40rem, 1fr));
  justify-content: space-evenly;
  grid-gap: 2rem;
  margin-top: 2rem;
`;

export default styled(AttendantDashboard)`
  margin-top: 7rem;
  position: relative;

  header {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 2rem;
  }

  .data-columns {
    overflow-y: auto;
    scrollbar-color: grey ${setColor.mainGrey};
    height: 100%;

    /* scrollbar-width: none;

    ::-webkit-scrollbar {
      display: none;
    } */
  }
  .ReactModal {
    padding: 10px;
  }
  .table {
    height: 100%;
  }

  .row-data {
    padding: 0.2rem 0.4rem;
  }

  .row {
    display: flex;
    flex-direction: row;
    transition: 0.2s;

    :not(:last-child) {
      border-bottom: 1px solid rgba(100, 100, 100, 0.2);
    }

    :hover {
      transform: scale(1.01);
      transition: 0.2s;
    }
  }
  #meeting_complete {
    margin-left: 10px !important;
  }
  .details_button {
    display: flex;
    align-items: center;
  }
  .rowCompleted {
    display: flex;
    flex-direction: row;
    transition: 0.2s;

    :not(:last-child) {
      border-bottom: 1px solid rgba(100, 100, 100, 0.2);
    }
    .emailMeetings,
    .first-nameMeetings,
    .last-nameMeetings {
      text-decoration: line-through;
    }
    :hover {
      transform: scale(1.01);
      transition: 0.2s;
    }
  }

  .emailDropCards {
    width: 50%;
    text-overflow: ellipsis;
    overflow: hidden;
    align-self: center;
  }

  .first-nameDropCards {
    width: 25%;
    text-overflow: ellipsis;
    overflow: hidden;
    align-self: center;
  }

  .last-nameDropCards {
    width: 25%;
    text-overflow: ellipsis;
    overflow: hidden;
    align-self: center;
  }

  .emailMeetings {
    width: 40%;
    text-overflow: ellipsis;
    overflow: hidden;
    align-self: center;
  }

  .first-nameMeetings {
    width: 20%;
    text-overflow: ellipsis;
    overflow: hidden;
    align-self: center;
  }

  .last-nameMeetings {
    width: 20%;
    text-overflow: ellipsis;
    overflow: hidden;
    align-self: center;
  }

  .detailsMeetings {
    text-overflow: ellipsis;
    overflow: hidden;
    align-self: center;
    margin-left: -30px;
  }

  h1 {
    text-align: center;
  }

  object {
    height: 100%;
    width: 100%;
  }
`;
